import { Link } from 'react-router-dom'
import { business, navLinks, services } from '../data/siteData'
import SocialIcons from './SocialIcons'
import './Footer.css'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="footer-band">
      {/* <div className="footer-glow" aria-hidden="true" /> */}
      <div className="container footer-top">
        <div className="footer-col footer-brand">
          <div className="footer-logo">
            <span className="footer-logo-mark">
              <img
                src="/images/logo/logo.webp"
                alt=""
                width="500"
                height="500"
                onError={(e) => (e.currentTarget.style.display = 'none')}
              />
            </span>
            <span className="footer-logo-text">AS Elite Gatherings</span>
          </div>
          <p className="footer-tagline">
            Corporate events, product launches, private parties, weddings and stage
            decoration — planned and produced in Marthandam and beyond.
          </p>
          <SocialIcons variant="band" />
        </div>

        <div className="footer-col">
          <h4>Explore</h4>
          <ul>
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to}>{l.label}</Link>
              </li>
            ))}
            <li>
              <Link to="/booking">Book an Event</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Services</h4>
          <ul>
            {services.slice(0, 5).map((s) => (
              <li key={s.id}>
                <Link to={`/services#${s.id}`}>{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Reach Us</h4>
          <ul className="footer-contact">
            <li>
              <a href={business.mapsLink} target="_blank" rel="noreferrer">
                {business.addressLines.map((line, i) => (
                  <span key={i} className="addr-line">{line}</span>
                ))}
              </a>
            </li>
            <li>
              <a href={business.phoneHref}>{business.phone}</a>
            </li>
            <li>
              <a href={`mailto:${business.email}`}>{business.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container footer-bottom">
        <p>© {year} AS Elite Gatherings. All rights reserved.</p>
      </div>
    </footer>
  )
}
